import { useActionParam } from '@api/actions/action';
import { useCallback, useEffect, useState } from '@wordpress/element';
import { POST_ID } from '../../routes/Variables';

export const useAnalisesPostObter = ({ idPost = POST_ID, acaoWp = '', tipo = '' }) => {
  const [resultado, setResultado] = useState({
    analise: null,
    erro: null,
    carregando: false,
  });

  const { mutateAsync: obterAnaliseWp } = useActionParam();

  const obterAnalises = useCallback(async () => {    
    if (!idPost) {
      setResultado(prev => ({
        ...prev,
        erro: new Error('ID do post não fornecido!'),
        carregando: false,
      }));
      return;
    }

    try {
      setResultado(prev => ({ ...prev, carregando: true, erro: null }));

      const res = await obterAnaliseWp({
        action: acaoWp,
        param: {
          post_id: parseInt(idPost, 10),
          tipo,
        },
      });

      if (!res.success) {
        setResultado({
          analise: [],
          erro: null,
          carregando: false,
        });

        return;
      }      

      setResultado({
        analise: JSON.parse(res.data[0]?.analises),
        carregando: false,
        erro: null,
      });
      
    } catch (error) {
      console.error(`Erro em obterAnalises: ${error}`)
      setResultado(prev => ({ ...prev, erro: error, carregando: false }));
    }
  }, [idPost, obterAnaliseWp]);

  useEffect(() => {
    obterAnalises();
  }, [obterAnalises, idPost]);

  return { obterAnalises, resultado };
};
